import { DialogContent } from '@mui/material';
import { FC, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import AppSpinner from '../../common/components/AppSpinner';
import { scanAll, useIsScanning } from '../../new-scan/actions/scan-actions';
import DiscoveryStore from '../../new-scan/store/discovery-store';

import OnBoardingDiscovery from '../components/OnBoardingDiscovery';
import { setOnboardingStep } from '../store-actions/onboarding-store-actions';

const OnboardingDiscoveryContainer: FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { value, total, info } = useSnapshot(DiscoveryStore);
  const isScanning = useIsScanning();

  useEffect(() => {
    scanAll();
    return () => {
      setOnboardingStep(null);
    };
  }, []);

  if (!isScanning) {
    return (
      <AppSpinner disablePositionAbsolute text='Initializing discovery phase' />
    );
  }

  return (
    <>
      <DialogContent>
        <OnBoardingDiscovery total={total} value={value} info={info} />
      </DialogContent>
    </>
  );
};

export default OnboardingDiscoveryContainer;
